export const getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");
    if (sParameterName[0] === sParam) {
      let param = decodeURIComponent(sParameterName[1]);
      const preventReload =
        window.dynamicReview !== false &&
        localStorage.getItem("preventReload") !== null;
      if (sParam === "tracking_number" && preventReload) {
        param = "";
      }
      return sParameterName[1] === undefined ? true : param;
    }
  }
};

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const BASE_URL_NEW = process.env.REACT_APP_BASE_URL_NEW;
export const CORE_SERVICE_URL = process.env.REACT_APP_CORE_SERVICE_URL;

export const RELATED_URL =
  "https://apps.omegatheme.com/viewed-products/viewed-products.php";
export const SHOP = window.Shopify?.shop ?? getUrlParameter("shop") ?? "";
export const tracking_number =
  window.Shopify?.tracking_number ?? getUrlParameter("tracking_number") ?? "";
export const order_id =
  window.Shopify?.tracking_number ?? getUrlParameter("order_id") ?? "";
